module.exports = __webpack_public_path__ + "static/media/ding-1.024ebba1.wav";